import { render, staticRenderFns } from "./OnlCgreportAutoList.vue?vue&type=template&id=5a4fa1dc&scoped=true&"
import script from "./OnlCgreportAutoList.vue?vue&type=script&lang=js&"
export * from "./OnlCgreportAutoList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgreportAutoList.vue?vue&type=style&index=0&id=5a4fa1dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4fa1dc",
  null
  
)

export default component.exports